// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.SchedulingSearchResult.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var { find } = require('lodash/fp');

  var extendObservable = require('mobx').extendObservable;
  var asMap = require('mobx').asMap;
  var action = require('mobx').action;
  var SchedulingSearchGrid = require('./Izenda.SchedulingSearchGrid');

  function SchedulingSearchResult(data) {
    extendObservable(this, {
      systemSearchResult: new SchedulingSearchGrid(),
      tenantSearchResult: asMap({}),
      isEmpty: function() {
        var isEmpty = true;
        var tenantSearchResult = this.tenantSearchResult;
        var keys = tenantSearchResult.keys();
        for (var i = 0; i < keys.length; i++) {
          isEmpty = tenantSearchResult.get(keys[i]).isEmpty;
          if (!isEmpty) {
            break;
          }
        }
        return this.systemSearchResult.isEmpty && isEmpty;
      }
    });

    data && this.populateData(data);
  }

  /**
   * Populate search result data
   */
  SchedulingSearchResult.prototype.populateData = action(function(data, pageInfo) {
    var result = data.result;
    // System Schedules
    var systemSchedule = find({ tenantId: null, tenantName: null }, result);
    systemSchedule && (this.systemSearchResult = new SchedulingSearchGrid(systemSchedule, pageInfo));

    // Tenant Scheduling
    result
      .filter(function(item) {
        return !!item.tenantId && !!item.tenantName;
      })
      .forEach(
        function(tenantSchedules) {
          this.tenantSearchResult.set(tenantSchedules.tenantName, new SchedulingSearchGrid(tenantSchedules, pageInfo));
        }.bind(this)
      );
  });

  module.exports = SchedulingSearchResult;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SchedulingSearchResult.js